import axiosInstance from "../api.axiosInstance"
import type {
  AssociateVppIncentivesPayload,
  EligibleVppProgramDto,
  ProposalVppIncentiveDto,
} from "../dto/proposal-vpp-incentive.dto"

export class ProposalVppIncentiveService {
  async fetchEligiblePrograms(
    proposalId: string,
  ): Promise<EligibleVppProgramDto[]> {
    const response = await axiosInstance.get<EligibleVppProgramDto[]>(
      `proposal/v1/${proposalId}/vpp-incentives/eligible`,
    )
    return response.data
  }

  async fetchAssociations(
    proposalId: string,
  ): Promise<ProposalVppIncentiveDto[]> {
    const response = await axiosInstance.get<ProposalVppIncentiveDto[]>(
      `proposal/v1/${proposalId}/vpp-incentives`,
    )
    return response.data
  }

  async associatePrograms(
    proposalId: string,
    payload: AssociateVppIncentivesPayload,
  ): Promise<ProposalVppIncentiveDto[]> {
    const response = await axiosInstance.post<ProposalVppIncentiveDto[]>(
      `proposal/v1/${proposalId}/vpp-incentives`,
      payload,
    )
    return response.data
  }

  async deleteAssociation(
    proposalId: string,
    vppProgramId: string,
  ): Promise<void> {
    await axiosInstance.delete(
      `proposal/v1/${proposalId}/vpp-incentives/${vppProgramId}`,
    )
  }
}

export const proposalVppIncentiveService = new ProposalVppIncentiveService()
